import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withCustomValidation } from '@bingads-webui-react/validation';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { UrlRulesImpl } from './url-rules-impl';

const UrlRules = ({ validationProps, updateValidation, enableSpecialCharactersValidation }) => {
  const activity = useContext(ActivityContext);
  const i18n = useContext(I18nContext);
  const { data: { urlRules, urlRulesOption } } = validationProps;
  const onChange = useCallback((newData) => {
    updateValidation([], newData);
    if (activity) {
      activity.signal(`onAssetGroupUrlRulesChange - ${JSON.stringify(newData)}`);
    }
  }, [updateValidation, activity]);

  return (
    <UrlRulesImpl
      i18n={i18n}
      urlRules={urlRules}
      urlRulesOption={urlRulesOption}
      onChange={onChange}
      enableSpecialCharactersValidation={enableSpecialCharactersValidation}
    />
  );
};

UrlRules.propTypes = {
  validationProps: PropTypes.shape({
    data: PropTypes.shape({
      urlRules: PropTypes.arrayOf(PropTypes.shape({
        Id: PropTypes.number,
        TargetCondition1: PropTypes.string,
        TargetConditionOperator1: PropTypes.string,
        TargetValue1: PropTypes.string,
        TargetCondition2: PropTypes.string,
        TargetConditionOperator2: PropTypes.string,
        TargetValue2: PropTypes.string,
        TargetCondition3: PropTypes.string,
        TargetConditionOperator3: PropTypes.string,
        TargetValue3: PropTypes.string,
      })),
      urlRulesOption: PropTypes.string,
    }),
  }).isRequired,
  updateValidation: PropTypes.func.isRequired,
  enableSpecialCharactersValidation: PropTypes.bool,
};

UrlRules.defaultProps = {
  enableSpecialCharactersValidation: false,
};

export const ValidatedUrlRules = withCustomValidation(UrlRules);
